import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("div", {
    staticClass: "message-warp"
  }, [_c("div", {
    staticClass: "wlc-pagination"
  }, [_c("div", {
    staticClass: "user-list"
  }, [_vm.userData[_vm.initiator.userId] && _vm.userData[_vm.searchForm.otherId] ? [_c("wlc-user-card", {
    attrs: {
      size: "small",
      info: _vm.userData[_vm.searchForm.userId] || {},
      isInitiator: _vm.searchForm.userId === _vm.initiator.userId
    }
  }), _c("wlc-user-card", {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      size: "small",
      info: _vm.userData[_vm.searchForm.otherId] || {},
      isInitiator: _vm.searchForm.otherId === _vm.initiator.userId
    }
  })] : _vm._e()], 2), _c("div", {
    staticClass: "right-pagination"
  }, [_c("el-button", {
    staticStyle: {
      margin: "-10px 0 10px 0"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("返回")]), _c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total,
      "pager-count": 3
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)]), _c("div", {
    staticClass: "messageRecord"
  }, [_c("div", {
    staticClass: "messageContent"
  }, _vm._l(_vm.tableData, function (item) {
    var _item$user, _item$user2, _item$user3, _item$parsedResult;
    return _c("div", {
      key: item.id,
      staticClass: "message-li"
    }, [(_item$user = item.user) !== null && _item$user !== void 0 && _item$user.avatar ? _c("wlc-image", {
      staticClass: "message-img",
      attrs: {
        src: (_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.avatar,
        compression: true,
        width: "50"
      }
    }) : _vm._e(), _c("div", {
      staticClass: "message-text"
    }, [_c("p", [_c("span", {
      staticClass: "message-user"
    }, [_vm._v(_vm._s((_item$user3 = item.user) === null || _item$user3 === void 0 ? void 0 : _item$user3.name))]), _c("span", {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(item.create))])]), item.objectName == "RC:TxtMsg" ? _c("div", {
      staticClass: "message-c",
      domProps: {
        innerHTML: _vm._s(_vm.textMessageFormat(item.msg))
      }
    }) : _vm._e(), item.objectName == "fraudTip" ? _c("div", {
      staticClass: "message-c",
      domProps: {
        innerHTML: _vm._s(item.msg)
      }
    }) : _vm._e(), item.objectName == "system" ? _c("div", {
      staticClass: "message-c"
    }, [item.msg.MsgType == "TIMTextElem" ? _c("span", [_vm._v(_vm._s(item.msg.MsgContent.Text))]) : item.msg.MsgType == "TIMImageElem" ? _c("wlc-image", {
      attrs: {
        src: item.msg.MsgContent.ImageInfoArray[0].URL,
        width: "200"
      }
    }) : item.msg.MsgType == "TIMCustomElem" ? _c("span", [_vm._v(_vm._s(item.msg.MsgContent.Desc))]) : _c("span", [_vm._v(_vm._s(item.msg))])], 1) : _vm._e(), item.objectName == "RC:ImgMsg" ? _c("div", [_c("wlc-image", {
      attrs: {
        src: item.msg.indexOf("rongcloud") > -1 || item.msg.indexOf("wellcee.com") > -1 || item.msg.indexOf("myqcloud.com") > -1 ? item.msg : "data:image/jpeg;base64," + item.msg,
        width: "200"
      }
    })], 1) : _vm._e(), item.objectName == "comment" ? _c("div", [_vm._v(" " + _vm._s(item.msg.fromUser && item.msg.fromUser.name) + " "), _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v(_vm._s(item.msg.content || item.msg))])], 1) : _vm._e(), item.objectName == "collect" ? _c("div", [_vm._v(" " + _vm._s(item.msg.fromUser && item.msg.fromUser.name) + " "), _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("收藏了房源")])], 1) : _vm._e(), item.objectName == "RC:LBSMsg" ? _c("div", [_c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("位置消息")])], 1) : _vm._e(), item.objectName == "RC:SightMsg" ? _c("div", [_c("video", {
      staticStyle: {
        width: "160px"
      },
      attrs: {
        src: item.msg,
        controls: ""
      }
    })]) : _vm._e(), item.objectName == "RC:VcMsg" ? _c("div", [_c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("语音消息")])], 1) : _vm._e(), item.objectName == "RC:HQVCMsg" ? _c("div", {
      staticClass: "audio-box"
    }, [_c("audio", {
      attrs: {
        controls: "",
        src: item.msg.remoteUrl
      }
    }), _c("div", [item !== null && item !== void 0 && (_item$parsedResult = item.parsedResult) !== null && _item$parsedResult !== void 0 && _item$parsedResult.result ? _c("div", {
      staticClass: "parsed-result"
    }, [_vm._v(" " + _vm._s(item.parsedResult.result) + " ")]) : _vm._e()])]) : _vm._e()])], 1);
  }), 0)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };